import { Action, Dispatch } from 'redux'
import { BrandState } from 'types/brand'
import { confirmBrandAction } from 'reducks/brand/actions'

const confirmBrand = (params: BrandState['confirm']) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(confirmBrandAction(params))
  }
}

export default confirmBrand
